import { ShopTypes } from 'src/services';

export function mapShopToGeneralSettings(shop: ShopTypes.ShopBase): ShopTypes.GeneralSettings {
  const { defaultLanguage, shopName, shopUrl } = shop;
  return { defaultLanguage, shopName, shopUrl };
}
